const RecyclingFolderStatusConstant = {
  PRODUCT_INFORMATION_SAVED: 'PRODUCT_INFORMATION_SAVED',
  PRODUCT_CHECKED: 'PRODUCT_CHECKED',
  PRODUCT_PACKAGED: 'PRODUCT_PACKAGED',
}

export default RecyclingFolderStatusConstant
